import maplibregl from "maplibre-gl";
import "maplibre-gl/dist/maplibre-gl.css";
import { createMap } from "./map";

export {
    maplibregl,
    createMap
};

// https://maplibre.org/maplibre-gl-js-docs/api/
